import { UIIcon } from '../config/icons';
import { the_login_scope } from '../lib/me/login';
import { UIAside } from '../lib/ui/aside';
import { onDetach } from '../lib/ui/attach';
import { UIButton } from '../lib/ui/component/button';
import { $el } from '../lib/ui/elements';
import { UIClassesSpec } from '../lib/ui/types';
import { UIView } from '../lib/ui/view';
import { $i18n } from '../lib/y/i18n';
import { $location } from '../lib/y/location';
import { producerShowLogin } from './login';

interface ProducerMenuOptions {
    classes?: UIClassesSpec;
    no_login?: boolean;
    no_logout?: boolean;
    is_signup?: boolean;
}

class HamburgerMenu extends UIAside {
    _toggle: () => void;

    constructor(toggle: () => void) {
        super('tl-hamburger-menu hidden');

        this._toggle = toggle;
    }

    override present() {
        return super.present({ position: 'left', backdrop_kind: 'darker', on_click: this._toggle, low: true });
    }
}


export class ProducerMenu extends UIView {
    signup_button?: UIButton;

    constructor(options: ProducerMenuOptions = {}) {
        super('header', ['tl-menu', options.classes]);

        let hamburger_menu: HamburgerMenu | undefined;
        const toggle_hamburger = () => {
            if(hamburger_menu) {
                hamburger_menu.dismiss(true);
                hamburger_menu = undefined;
                hamburger.checked = false;
            } else {
                this.classList.add('f-hamburger');
                this.classList.remove('f-search');
                hamburger.checked = true;
                hamburger_menu = new HamburgerMenu(toggle_hamburger);
                hamburger_menu.present();
            }
        };

        const hamburger = new UIButton({ kind: 'k-hamburger', title: 'MENY', alt: 'Meny', on_click: toggle_hamburger });

        onDetach(this, () => {
            if(hamburger_menu) {
                hamburger_menu.dismiss(true);
                hamburger_menu = undefined;
            }
        });

        const logo = $el.DIV('r-logo');
        logo.addEventListener('click', () => {
            $location.navigate([]);
        });

        this.ui_add([
            hamburger,
            $el.S(undefined, 'q-m'),
            logo,
            $el.S()
        ]);

        if(!options.no_login && !the_login_scope) {
            const button_on_click = () => { producerShowLogin('header_button'); };

            this.ui_add([
                new UIButton({ title: $i18n.tl.m_login, classes: 'm-hollow r-link', on_click: button_on_click }),
                new UIButton({ icon: UIIcon.RIGHT_TO_BRACKET, classes: 'q-m r-icon', on_click: button_on_click })
            ]);
        }
    }
}
